<template>
  <generic-modal
    v-on:destroy="destroy"
    size="large"
    :title="$t('role')"
    icon="id card"
    :scrolling="true"
    image="/images/icons/role_icon.png"
    v-bind:on_finished="this.finish"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="ui four item pointing secondary menu">
          <a class="active item" data-tab="general">
            <i class="id badge icon"></i>
            {{ $t("general") }}
          </a>
          <a class="item" data-tab="user_suscriptions" v-if="$props.role_id">
            <i class="users icon"></i>
            {{ $t("users") }}
          </a>
          <a class="item" data-tab="module_suscriptions" v-if="$props.role_id">
            <i class="cubes icon"></i>
            {{ $t("modules") }}
          </a>
          <a class="item" data-tab="permissions" v-if="$props.role_id">
            <i class="unlock icon"></i>
            {{ $t("permissions") }}
          </a>
        </div>
        <general
          class="ui active tab basic segment"
          :role="role"
          data-tab="general"
          ref="general"
        />
        <user-suscription
          class="ui tab basic segment"
          :role="role"
          data-tab="user_suscriptions"
          v-if="$props.role_id"
        />
        <module-suscription
          class="ui tab basic segment"
          :role="role"
          v-if="$props.role_id"
          data-tab="module_suscriptions"
          @updated="upate_module_suscriptions"
          ref="module_suscription"
        />
        <permissions
          class="ui tab basic segment"
          :role="role"
          data-tab="permissions"
          v-if="$props.role_id"
          ref="permissions"
        />

        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import General from "./General";
import UserSuscription from "./UserSuscription";
import ModuleSuscription from "./ModuleSuscription";
import Permissions from "./Permissions";
export default {
  name: "RoleModal",
  components: {
    "generic-modal": GenericModal,
    General,
    UserSuscription,
    ModuleSuscription,
    Permissions,
  },
  props: {
    role_id: Number,
  },
  mounted() {
    let vm = this;
    window.jQuery(this.$refs.form).form({
      fields: {
        name: ["empty"],
      },
      onSuccess() {},
    });

    /**
     * Init
     */

    if (vm.$props.role_id) {
      this.processing = true;
      local_api(vm, "post", "/user_role/do-get", {
        i: vm.$props.role_id,
      })
        .then((response) => {
          response.status = response.status_code == "A";
          response.resources = !response.resources
            ? []
            : response.resources.map((r) => {
                r.granted = r.usr_role_permissions.length > 0;
                return r;
              });
          vm.role = response;

          // vm.role.login_redirect_to = vm.role.login_redirect_to || "";
          if (vm.role.login_redirect_to) {
            vm.$refs.general.setRedirectTo(vm.role.login_redirect_to);
            // window
            //   .jQuery(vm.$refs.redirect_to_dropdown)
            //   .dropdown("set selected", vm.role.login_redirect_to);
          }

          setTimeout(() => {
            vm.$refs.permissions.init_table();
          }, 500);
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        })
        .finally(() => {
          this.processing = false;
        });

      console.log("init with", vm.$props.role_id);
      vm.$refs.module_suscription.init(vm.$props.role_id);
    }
  },
  data() {
    return {
      role: {
        role_id: null,
        name: "",
        description: "",
        login_redirect_to: "",
      },
    };
  },
  methods: {
    upate_module_suscriptions(modules) {
      let vm = this;
      vm.$refs.permissions.set_allowed_modules(
        modules.filter((m) => m.granted),
      );
      setTimeout(() => {
        vm.$refs.permissions.init_table();
      }, 500);
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finish() {
      let vm = this;

      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");

      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/user_role/do-save", {
            i: vm.role.role_id,
            n: vm.role.name,
            r: vm.role.login_redirect_to,
            d: vm.role.description,
            s: vm.role.status ? "A" : "I",
            p: !vm.role.resources
              ? []
              : vm.role.resources.map((r) => {
                  return { r: r.resource_id, g: r.granted };
                }),
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
  },
  updated() {
    let vm = this;
    this.$nextTick(function() {
      window
        .jQuery(vm.$el)
        .find(".ui.menu .item")
        .tab();
    });
  },
};
</script>
